import identifyQualifiedTraffic from "@utils/identifyQualifiedTraffic";
import { isMainOrMiddleClick } from "@utils/MouseEventButton";
import { handleCustomUDL } from "@utils/UDLUtils";

export class FatFooter {
  private ctx: HTMLElement;
  private abortController = new AbortController();

  constructor(element: HTMLElement) {
    this.ctx = element;
  }

  init(): this {
    const { signal } = this.abortController;
    this.ctx.querySelectorAll<HTMLElement>(".fatFooterItem").forEach((item) => {
      item.addEventListener("click", (e) => this.onClick(e), { signal });
      item.addEventListener("auxclick", (e) => this.onClick(e), { signal });
    });
    return this;
  }

  private onClick(e: MouseEvent): void {
    if (!isMainOrMiddleClick(e)) return;
    const linkElement = e.currentTarget as HTMLElement;
    handleCustomUDL("footer_navigation", {
      navigation_level_1: linkElement.outerText,
      link_url: linkElement.querySelector("a")?.href ?? "",
      ...identifyQualifiedTraffic(linkElement.querySelector("a")?.href ?? ""),
    });
  }

  destroy(): void {
    this.abortController.abort();
  }

  static initAll(): void {
    document
      .querySelectorAll<HTMLElement>('[data-component="fat-footer"]')
      .forEach((el) => new FatFooter(el).init());
  }
}

